import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const EvaluationTypeManagement = React.lazy(() => import('./EvaluationTypeManagement'));
const CategoryManagement = React.lazy(() => import('./CategoryManagement'));
const EvaluationTemplateEditor = React.lazy(() => import('./EvaluationTemplateEditor'));
const ReviewManagement = React.lazy(() => import('./ReviewManagement'));

type EvalTab = 'eval-types' | 'categories' | 'templates' | 'reviews';

const TABS: { key: EvalTab; label: string }[] = [
  { key: 'reviews', label: 'Reviews' },
  { key: 'categories', label: 'Category Catalog' },
  { key: 'templates', label: 'Templates' },
  { key: 'eval-types', label: 'Evaluation Types' },
];

export default function AdminConfigHub() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab') as EvalTab | null;
  const [activeTab, setActiveTab] = useState<EvalTab>(tabParam && TABS.some(t => t.key === tabParam) ? tabParam : 'reviews');

  const handleTabChange = (tab: EvalTab) => {
    setActiveTab(tab);
    setSearchParams({ tab }, { replace: true });
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 px-6 py-3">
        <h1 className="text-xl font-semibold text-gray-900">Evaluations</h1>
        <p className="text-sm text-gray-400 mt-0.5">Evaluation types, categories, templates and review assignments</p>
      </div>

      {/* Tabs */}
      <div className="border-b border-gray-200 px-6">
        <div className="flex gap-0 -mb-px">
          {TABS.map(tab => (
            <button key={tab.key} onClick={() => handleTabChange(tab.key)}
              className={`px-4 py-2.5 text-xs font-medium border-b-2 transition-colors ${
                activeTab === tab.key ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'
              }`}>{tab.label}</button>
          ))}
        </div>
      </div>

      {/* Tab content */}
      <React.Suspense fallback={
        <div className="flex items-center justify-center py-20">
          <div className="animate-spin h-5 w-5 border-2 border-blue-500 border-t-transparent rounded-full" />
        </div>
      }>
        {activeTab === 'eval-types' && <EvaluationTypeManagement />}
        {activeTab === 'categories' && <CategoryManagement />}
        {activeTab === 'templates' && <EvaluationTemplateEditor />}
        {activeTab === 'reviews' && <ReviewManagement />}
      </React.Suspense>
    </div>
  );
}
